import {useTranslation} from "react-i18next";
import {useEffect, useRef, useState} from "react";
import moment from "moment";
import {useNavigate} from "react-router-dom";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
// -
import {SwalAlertChoice, SwalAlertClass} from "core/swalClass";
import NavBreadcrumb from "components/NavBreadcrum";
import navs from "./navs";
import axiApi from "ApiCaller";
import FormButton from "components/buttons/FormButton";
import translations from "./recovery/translations";
import useCustomTranslation from "core/customTranslation";
import Form from "react-bootstrap/Form";
import MiniQForm from "./recovery/models/MiniQForm";
import MiniQ2Form from "./recovery/models/MiniQ2Form";
import ItemsModel from "../../core/itemsModel";


const MODELS_DATES = ["MQ2-4G"]

const ViewRecovery = () => {
    const {t: _Tr} = useTranslation("routes");
    const {t: _Tf} = useTranslation("forms");
    const {t: _TC} = useCustomTranslation(translations);
    const navigate = useNavigate();
    const title = "Recuperador de datos";
    document.title = title;
    const bread = [
        {name: _Tr("labels.history"), url: "/historic/", current: false},
        {name: title, current: true},
    ];
    const Alert = new SwalAlertClass({confirmButtonText: "Aceptar"});
    const Question = new SwalAlertChoice({
        icon: "info",
        confirmButtonText: _Tf("labels.accept"),
        cancelButtonText: _Tf("labels.cancel"),
    });
    const items = useRef(new ItemsModel());
    const [isSubmit, setIsSubmit] = useState(false);
    const [models, setModels] = useState([]);
    const [model, setModel] = useState("");
    const [dateRange, setDateRange] = useState({
        startDate: moment().startOf("day"),
        endDate: moment().endOf("day"),
    });

    useEffect(() => {
        axiApi.get("/api/recovery/models/").then((resp) => {
            setModels(resp.data.models);
        });
    }, []);

    const onSubmit = (e) => {
        setIsSubmit(true);
        e.preventDefault();
        e.stopPropagation();
        if (!model) {
            Alert.warning(_TC("needModel"));
            setIsSubmit(false);
            return;
        }
        if (!dateRange.startDate || !dateRange.endDate) {
            Alert.warning(_TC("needDateRange"));
            setIsSubmit(false);
            return;
        }
        let DataSend = {
            model: model,
            start_date: dateRange.startDate.format("YYYY-MM-DD HH:mm"),
            end_date: dateRange.endDate.format("YYYY-MM-DD HH:mm"),
            // end_date: "",
        };
        Question.fire(_TC("recoveryConfirm"))
            .then((result) => {
                // console.log(DataSend);
                if (result.isConfirmed) {
                    axiApi
                        .post("/api/recovery/send/", DataSend)
                        .then((resp) => {
                            if (resp.data.status) {
                                Alert.success(_TC("recoverySuccess"));
                                navigate("/historic/");
                            } else {
                                Alert.error(_TC("recoveryError"));
                            }
                        })
                        .catch((error) => {
                            console.error(error);
                        });
                }
            })
            .finally(() => {
                setIsSubmit(false);
            });
    };
    const handleModelChange = (e) => {
        setModel(e.target.value);
        items.current.reset();
    };
    // const selectDateRange = (e) => {
    //     const {name, value} = e.target;
    //     let dateRange_ = {...dateRange};
    //     switch (name) {
    //         case "start":
    //             dateRange_.startDate = moment(value);
    //             break;
    //         case "end":
    //             dateRange_.endDate = moment(value);
    //             break;
    //         default:
    //             break;
    //     }
    //     setDateRange(dateRange_);
    // };

    const selectDateRange = (e) => {
        const {value} = e.target;
        const dateRange_ = moment(value);

        setDateRange({
            startDate: dateRange_.clone().startOf("day"),
            endDate: dateRange_.clone().endOf("day"),
        });
    };

    const handleClose = () => {
        navigate("/advanced/");
    };

    const getFormModel = (model) => {
        switch (model) {
            case "MQ-SX":
            case "QT-2G":
                return <MiniQForm/>;
            case "MQ2-4G":
                return <MiniQ2Form model={model} items={items}/>;
            default:
                return <></>;
        }
    }
    return (
        <>
            <NavBreadcrumb bread={bread} navs={navs}/>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12 preview-canvas offcanvas-header mt-1">
                        <div className="preview-icon">
                            <FontAwesomeIcon icon="fa-clock-rotate-left"/>
                        </div>
                        <div className="preview-title ps-4">
                            <h5>{title}</h5>
                        </div>
                    </div>
                </div>

                <form className="row" onSubmit={onSubmit}>
                    <div className="col-12 mb-5">
                        <h2 className="text-center">
                            {_TC("recoveryDescription")}
                        </h2>
                        <div className="d-flex justify-content-center mt-4">
                            <div className="col-2">
                                <label
                                    style={{
                                        width: "120",
                                        fontWeight: "bold",
                                        textAlign: "center",
                                    }}
                                >
                                    Modelos
                                </label>
                                <Form.Select
                                    aria-label="Default select example"
                                    value={model}
                                    name="model"
                                    onChange={handleModelChange}
                                >
                                    <option value="">Seleccionar</option>
                                    {models.map((item, idx) => (
                                        <option key={idx} value={item}>
                                            {item}
                                        </option>
                                    ))}
                                </Form.Select>
                            </div>
                        </div>
                        {getFormModel(model)}
                    </div>
                    <div className="row fixed-bottom me-3">
                        <div className="text-end col-12 mb-4">
                            <button
                                type="button"
                                className="btn btn-secondary me-4"
                                onClick={handleClose}
                            >
                                {_Tf("labels.cancel")}
                            </button>
                            <FormButton
                                type="submit"
                                className="btn btn-primary"
                                isProcessing={isSubmit}
                            >
                                {_Tf("labels.send")}
                            </FormButton>
                        </div>
                    </div>
                </form>
            </div>
        </>
    );
};

export default ViewRecovery;
